import { useNavigate } from 'react-router-dom'
import { Paper, Stack, Text, Group, Button } from '@mantine/core'
import { IconChartRadar } from '@tabler/icons-react'

export function TeamStoryHistory({ teamId, history = [] }) {
  const navigate = useNavigate()

  if (history.length === 0) return null

  return (
    <Paper p="lg" className="glass">
      <Stack gap="sm">
        <Text size="xs" c="dimmed" ff="Orbitron, sans-serif" tt="uppercase" lts={1}>
          Past Stories
        </Text>
        {history.map((entry) => (
          <Group key={entry.team_story_id} justify="space-between" align="center" wrap="nowrap">
            <Stack gap={0}>
              <Text size="sm" fw={600}>{entry.story_name}</Text>
              {entry.completed_at && (
                <Text size="xs" c="dimmed">
                  Completed {new Date(entry.completed_at).toLocaleDateString()}
                </Text>
              )}
            </Stack>
            <Button
              size="xs"
              variant="light"
              color="cyan"
              leftSection={<IconChartRadar size={14} />}
              onClick={() => navigate(`/teams/${teamId}/analysis/${entry.team_story_id}`)}
            >
              Team Analysis
            </Button>
          </Group>
        ))}
      </Stack>
    </Paper>
  )
}
